import { Copy } from "lucide-react";
import { copyText } from "@/components/PdPill";
import { fmtTs } from "@/components/sms/smsUtils";

const SRC = { phone: "Gmail", forwarder: "Phone", paste: "Paste" };

export const CodesTable = ({ rows, page, limit }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm" data-testid="sms-codes-table">
      <thead>
        <tr className="text-left text-[10px] uppercase tracking-[0.16em] text-[#6B6B61] border-b border-[#E0DFD6]">
          <th className="py-2 pr-3 w-12">#</th>
          <th className="py-2 pr-3">Time</th>
          <th className="py-2 pr-3">Mobile</th>
          <th className="py-2 pr-3">Code</th>
          <th className="py-2 pr-3">From</th>
          <th className="py-2 pr-3">Status</th>
          <th className="py-2 w-10" />
        </tr>
      </thead>
      <tbody>
        {rows.map((r, i) => (
          <tr key={r.id} className="border-b border-[#F0EFE8] hover:bg-[#FAFAF6] transition-colors" data-testid={`sms-code-row-${r.id}`}>
            <td className="py-2 pr-3 text-[#9A9A90] tabular-nums">{(page - 1) * limit + i + 1}</td>
            <td className="py-2 pr-3 text-[#6B6B61] whitespace-nowrap">{fmtTs(r.received_ts)}</td>
            <td className="py-2 pr-3 font-mono font-semibold text-[#1C1C19]">{r.mobile}</td>
            <td className="py-2 pr-3 font-mono text-[#385C4B]">{r.code}</td>
            <td className="py-2 pr-3 text-xs text-[#6B6B61]">{SRC[r.source] || r.source}</td>
            <td className="py-2 pr-3">
              <span className={`text-[10px] font-semibold uppercase px-2 py-0.5 rounded-full ${r.copied ? "bg-[#EFEEE6] text-[#6B6B61]" : "bg-emerald-100 text-emerald-800"}`}>
                {r.copied ? "Copied" : "New"}
              </span>
            </td>
            <td className="py-2">
              <button onClick={() => copyText(`${r.mobile}\t${r.code}`, r.mobile)} className="p-1.5 rounded hover:bg-[#EFEEE6] text-[#6B6B61]"
                aria-label="Copy row" data-testid={`sms-copy-row-${r.id}`}>
                <Copy className="w-3.5 h-3.5" />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    {!rows.length && <div className="py-12 text-center text-sm text-[#9A9A90]" data-testid="sms-codes-empty">Koi code nahi mila.</div>}
  </div>
);
